<div class="qcontainer">
  <form fxLayout="column" id="mediaFilterForm" [formGroup]="mediaFilterForm">
    <div fxLayout="row">
      <div class="form-field">
        <mat-form-field>
          <input matInput autocomplete="off" placeholder="Word Order Id" type="number" name="workOrderId"
            formControlName="workOrderId">
          <mat-error *ngIf="mediaFilterForm.get('workOrderId').hasError('pattern')">Must be a
            number.</mat-error>
        </mat-form-field>
      </div>
    </div>
    <div>
      <span class="pl-2">- or - </span>
    </div>
    <div class="flex flex-row">
      <div class="form-field">
        <mat-form-field>
          <input matInput autocomplete="off" placeholder="Appointment Id" type="number" name="appointmentId"
            formControlName="appointmentId">
          <mat-error *ngIf="mediaFilterForm.get('appointmentId').hasError('pattern')">Must be a
            number.</mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="flex flex-row place-content-center place-items-center button-container">
      <button id="apply-filters-button" type="button" mat-raised-button color="primary"
        (click)="apply(mediaFilterForm.value)" [disabled]="mediaFilterForm.invalid">Apply</button>
    </div>
  </form>
</div>